// Collection grid: infinite scroll by appending the next page's cards (Section Rendering API), toolbar auto-submit.
class CollectionGrid extends HTMLElement {
  connectedCallback() {
    this.grid = this.querySelector('[data-grid]'); this.more = this.querySelector('[data-load-more]');
    if (this.more?.dataset.nextUrl) {
      this.io = new IntersectionObserver((entries) => { if (entries.some((e) => e.isIntersecting)) this.loadMore(); }, { rootMargin: '200px' });
      this.io.observe(this.more);
    }
    this.querySelectorAll('[data-toolbar-submit]').forEach((el) => el.addEventListener('change', () => el.form.requestSubmit()));
  }
  async loadMore() {
    if (this.loading || !this.more?.dataset.nextUrl) return;
    this.loading = true; this.more.dataset.loading = '';
    try {
      const url = new URL(this.more.dataset.nextUrl, location.href); url.searchParams.set('section_id', this.dataset.section);
      const html = new DOMParser().parseFromString(await (await fetch(url)).text(), 'text/html');
      const cards = html.querySelectorAll('[data-grid] > *'); cards.forEach((c) => this.grid.appendChild(c));
      document.dispatchEvent(new CustomEvent('rosae:grid:appended', { detail: { count: cards.length } }));
      const next = html.querySelector('[data-load-more]')?.dataset.nextUrl;
      if (next) { this.more.dataset.nextUrl = next; this.more.querySelector('a')?.setAttribute('href', next); }
      else { this.io.disconnect(); this.more.remove(); this.more = null; }
    } catch (e) { /* keep the link as a fallback */ }
    finally { this.loading = false; this.more?.removeAttribute('data-loading'); }
  }
}
if (!customElements.get('collection-grid')) customElements.define('collection-grid', CollectionGrid);
